module.exports = ".toggle{margin-top:-4rem}.d-flex.wrap{-ms-flex-flow:wrap;flex-flow:wrap}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/container/container.component.sass
// module id = ./src/app/modules/dashboard/container/container.component.sass
// module chunks = main